<mat-nav-list appAccordion>
  <div class="text-center">
    <img height="50px" class="logo_ p-2 mb-5" src="../../../../assets/images/green_logo_1.svg" />
  </div>

  <div *ngFor="let menuitem of menuItems.getMenuitem(); index as i">
    <mat-list-item appAccordionLink group="{{ menuitem.state }}" *ngIf="menuitem.show">
      <a (click)="activeRoute(i, menuitem.type)" [ngClass]="{ selected: readLocalStorageValue('activeIndex') == i }"
        appAccordionToggle [routerLink]="[menuitem.state]">
        <span *ngIf="readLocalStorageValue('activeIndex') !== i"><img class="logo_icon"
            [src]="menuitem.iconUrl" /></span>
        <span *ngIf="readLocalStorageValue('activeIndex') == i"><img class="logo_icon"
            [src]="menuitem.iconUrlActive" /></span>
        <span class="menu_label">{{ menuitem.name }} </span>
      </a>
    </mat-list-item>
  </div>
  <div></div>
</mat-nav-list>